import { forwardRef } from "react";
import { CircularProgress } from "@mui/material";
import { Button as MUIButton, type ButtonProps } from "src/components-mui/base/button/button";

interface IResultsButtonProps extends ButtonProps {
    isLoading?: boolean;
}

// Dev-Note: custom button wrapper is needed to override MUI mechanism which disables button when isLoading is true
export const MobileResultsButton = forwardRef<HTMLButtonElement, IResultsButtonProps>(({ isLoading, children, ...restButtonProps }, ref) => {
    return (
        <MUIButton ref={ref} {...restButtonProps}>
            {isLoading ? (
                <>
                    <CircularProgress size={16} sx={{ color: "white" }} />
                </>
            ) : (
                <>{children}</>
            )}
        </MUIButton>
    );
});

MobileResultsButton.displayName = "ResultsButton";
